module.exports = __webpack_public_path__ + "static/media/paying-for-order.5d25750d.jpg";